import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityDetailPage } from "../shared/EntityDetailPage";

export function CustomerDetailPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityDetailPage
      entityType="customer"
      listPath={`${adminPath}/mdm/customers`}
    />
  );
}
